import React, { memo } from 'react';
import styled, { keyframes } from 'styled-components';

import { Card } from '../../../../../components';

// Shimmer keyframes
const shimmer = keyframes`
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
`;

const ShimmerSkeleton = styled.div`
  background: linear-gradient(90deg, var(--gray-8) 25%, var(--gray-4) 50%, var(--gray-8) 75%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.6s linear infinite;
  border-radius: 6px;
`;

const ShimmerTitle = styled(ShimmerSkeleton)`
  height: 24px;
  width: 40%;
`;

const ShimmerSubtitle = styled(ShimmerSkeleton)`
  height: 24px;
  width: 85%;
  margin-bottom: 10px;
`;

const ShimmerContent = styled(ShimmerSkeleton)`
  height: 280px;
  width: 100%;
  margin: 0 -20px -20px;
  width: calc(100% + 40px);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
`;

const AssetCardSkeleton = memo(() => (
  <Card>
    <ShimmerTitle />
    <ShimmerSubtitle />
    <ShimmerContent />
  </Card>
));

export { AssetCardSkeleton };
